// src/components/shared/ContentData.js

export const menuItems = ['music', 'tickets', 'about', 'information'];  // 'play' removed

export const getContent = (section) => {
  switch(section) {
    case 'music':
      return {
        title: 'Music',
        content: {
          title: 'Music',
          description: [
            'Search invites participants to explore, discover and fall for musical offerings that straddles across boundaries of genre and expectations. We want your hearts, minds and soles to be enthralled and elevated through music that moves, soothes, challenges and channels. Our lineups aim to showcase the talent in the local community, and also believe in fostering global connections that de-emphasize national boundaries.',
            'See our roster of previous artists here.',
            'First artist announcements for Search Festival 2025 coming soon!'
          ]
        }
      };

    case 'about':
      return {
        title: 'About',
        content: {
          title: 'About',
          description: [
            'Search Festival is an annual gathering of like-spirited ravers, musicians and builders to collectively create a spectacle for the senses. We platform the music we like, presenting an eclectic offering of electric substance. Search Festival is an intimate gathering, with capped attendance to help throw a coherent claypot of experience to dunk ourselves in.',
            'Search is founded on DIY principles. If we can do it ourselves (legally and safely), we will. The planning, organisation and creative output is motivated by passion, people, and pleasure, rather than profit. You will not be surrounded by brand activations and corporate banners, so do not expect a smoothly sanded 5-star experience either. We are not polishing anyone\'s shoes here, and we build our own scaffolding to be rough around the edges.',
            'Search has always been driven through a culture of volunteering and contributions, and liberally give free tickets for anyone whose currency is their creativity and collaborative spirit. 25% of the attendants are directly involved in making the event happen, as a volunteer, musician, artist, stage manager and the like. The other 75% are equally essential, through funding the event (it is not possible without you!).',
            'At Search we love that everything is flux. Change is great, and we keep things surprising every year. If we are not changed by experiences and not looking actively looking for surprises, something is amiss. What stays the same at Search is the nature of your sonic experience, in whatever form that is taken.'
          ]
        }
      };

    case 'tickets':
      return {
        title: 'Tickets',
        content: {
          title: 'Tickets',
          description: [
            'Early bird presale available now. Available on Quicket'
          ]
        }
      };

    case 'information':
      return {
        title: 'Information',
        content: {
          title: 'Festival Information',
          sections: [
            {
              title: 'The Basics',
              content: [
                'Outdoor camping. Food stalls. Toilets. Showers. LIMITED WATER - bringing enough of own water for drinking.'
              ]
            },
            {
              title: 'Foundational Principles',
              content: [
                'Be lekker - What else are we here for? Search was born out of a need for a festival space where you could rave without dark, toxic elements clouding your heights. The dancefloor is where we repair, not rupture. So keep the belligerence outside.',
                'Be safe - Do not start dangerous fires. Protect your toes. Stay hydrated.',
                'Do not be a naai'
              ]
            },
            {
              description: [
                'Search has always been premised on the idea that collective responsibility is necessary for individual freedom. When we look after each other, we can spread our wings with confidence and flourish. Embrace the world, engage in communal perception, and be responsive to the needs of others.',
                'At Search, we tolerate everything except for intolerance. We stand firmly against all forms of racism, sexism, homophobia, transphobia, xenophobia and ageism. We do our best to provide a safe and secure environment for everyone involved, but we cannot control your behaviour. All we can do is remove it. Any instances of violent behaviour or harassment will be removed swiftly. The world has seen too much aggression already - keep it away from our dancefloors, please.',
                'You can read our safety policy, code of conduct and terms and conditions here.'
              ]
            }
          ]
        }
      };

    default:
      return null;
  }
};

export const BREAKPOINTS = {
  mobile: 768
};

export const COLORS = {
  background: '#eeedd8',
  content: 'rgba(211,212,205, 0.95)',
  text: '#000000',
  boid: '#016341',
  specialBoid: '#ff0000'
};

export const FONTS = {
  primary: 'Switzer, sans-serif'
};